var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsChevronDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.823 11.841a.833.833 0 0 1 1.1 1.248l-3.334 3.334-.078.069a.833.833 0 0 1-1.1-.07L6.077 13.09l-.069-.078a.833.833 0 0 1 .07-1.1l.078-.07a.833.833 0 0 1 1.1.07L10 14.654l2.744-2.743zM10.51 3.508l.078.07 3.334 3.333a.833.833 0 0 1-1.1 1.248l-.079-.07L10 5.346 7.256 8.089c-.3.3-.773.324-1.1.07l-.079-.07a.833.833 0 0 1-.069-1.1l.07-.078L9.41 3.577c.3-.3.773-.323 1.1-.069z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChevronDouble);
export default __webpack_public_path__ + "static/media/icons-chevron-double.151c109f9fd5d362b1d99e893054bf43.svg";
export { ForwardRef as ReactComponent };